// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceStatusType } from './IInvoiceStatusType';
import {
    IInvoiceStatusTypeFromJSON,
    IInvoiceStatusTypeFromJSONTyped,
    IInvoiceStatusTypeToJSON,
    IInvoiceStatusTypeToJSONTyped,
} from './IInvoiceStatusType';
import type { IInvoiceType } from './IInvoiceType';
import {
    IInvoiceTypeFromJSON,
    IInvoiceTypeFromJSONTyped,
    IInvoiceTypeToJSON,
    IInvoiceTypeToJSONTyped,
} from './IInvoiceType';
import type { IReasonCodeResponseDto } from './IReasonCodeResponseDto';
import {
    IReasonCodeResponseDtoFromJSON,
    IReasonCodeResponseDtoFromJSONTyped,
    IReasonCodeResponseDtoToJSON,
    IReasonCodeResponseDtoToJSONTyped,
} from './IReasonCodeResponseDto';

/**
 * 
 * @export
 * @interface IInvoiceDetailsAggregatorDto
 */
export interface IInvoiceDetailsAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {IInvoiceStatusType}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    invoice_status_type?: IInvoiceStatusType;
    /**
     * 
     * @type {IInvoiceType}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    invoice_type?: IInvoiceType;
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    ended_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    created_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    invoice_posting_sum?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    large_organization_logo?: string;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {Set<IReasonCodeResponseDto>}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    reason_codes?: Set<IReasonCodeResponseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    is_repull_manually_allowed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    account_number_last4?: string;
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    initial_funds_request?: Date;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    ach_method?: IInvoiceDetailsAggregatorDtoAchMethodEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IInvoiceDetailsAggregatorDto
     */
    repull_manually_allowed?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IInvoiceDetailsAggregatorDtoAchMethodEnum {
    NONE = 'NONE',
    PUSH = 'PUSH',
    PULL = 'PULL'
}


/**
 * Check if a given object implements the IInvoiceDetailsAggregatorDto interface.
 */
export function instanceOfIInvoiceDetailsAggregatorDto(value: object): value is IInvoiceDetailsAggregatorDto {
    return true;
}

export function IInvoiceDetailsAggregatorDtoFromJSON(json: any): IInvoiceDetailsAggregatorDto {
    return IInvoiceDetailsAggregatorDtoFromJSONTyped(json, false);
}

export function IInvoiceDetailsAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceDetailsAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_status_type': json['invoice_status_type'] == null ? undefined : IInvoiceStatusTypeFromJSON(json['invoice_status_type']),
        'invoice_type': json['invoice_type'] == null ? undefined : IInvoiceTypeFromJSON(json['invoice_type']),
        'ended_at': json['ended_at'] == null ? undefined : (new Date(json['ended_at'])),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'invoice_posting_sum': json['invoice_posting_sum'] == null ? undefined : json['invoice_posting_sum'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'large_organization_logo': json['large_organization_logo'] == null ? undefined : json['large_organization_logo'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'reason_codes': json['reason_codes'] == null ? undefined : (new Set((json['reason_codes'] as Array<any>).map(IReasonCodeResponseDtoFromJSON))),
        'is_repull_manually_allowed': json['isRepullManuallyAllowed'] == null ? undefined : json['isRepullManuallyAllowed'],
        'description': json['description'] == null ? undefined : json['description'],
        'account_number_last4': json['account_number_last4'] == null ? undefined : json['account_number_last4'],
        'initial_funds_request': json['initial_funds_request'] == null ? undefined : (new Date(json['initial_funds_request'])),
        'ach_method': json['ach_method'] == null ? undefined : json['ach_method'],
        'repull_manually_allowed': json['repull_manually_allowed'] == null ? undefined : json['repull_manually_allowed'],
    };
}

export function IInvoiceDetailsAggregatorDtoToJSON(json: any): IInvoiceDetailsAggregatorDto {
    return IInvoiceDetailsAggregatorDtoToJSONTyped(json, false);
}

export function IInvoiceDetailsAggregatorDtoToJSONTyped(value?: IInvoiceDetailsAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_status_type': IInvoiceStatusTypeToJSON(value['invoice_status_type']),
        'invoice_type': IInvoiceTypeToJSON(value['invoice_type']),
        'ended_at': value['ended_at'] == null ? undefined : ((value['ended_at']).toISOString()),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'amount': value['amount'],
        'invoice_posting_sum': value['invoice_posting_sum'],
        'organization_name': value['organization_name'],
        'large_organization_logo': value['large_organization_logo'],
        'organization_id': value['organization_id'],
        'reason_codes': value['reason_codes'] == null ? undefined : (Array.from(value['reason_codes'] as Set<any>).map(IReasonCodeResponseDtoToJSON)),
        'isRepullManuallyAllowed': value['is_repull_manually_allowed'],
        'description': value['description'],
        'account_number_last4': value['account_number_last4'],
        'initial_funds_request': value['initial_funds_request'] == null ? undefined : ((value['initial_funds_request']).toISOString()),
        'ach_method': value['ach_method'],
        'repull_manually_allowed': value['repull_manually_allowed'],
    };
}

